export const GOLD_KIND_ANTAM_SCAN = 1;
export const GOLD_KIND_LM_OTHER = 2;
export const GOLD_KIND_JEWELERY = 3;
export const GOLD_KIND_ANTAM_RETRO = 4;

export const GOLD_KIND_OPTIONS = [
    { id: GOLD_KIND_ANTAM_SCAN, name: "Antam Scan" },
    { id: GOLD_KIND_LM_OTHER, name: "LM Lainnya" },
    { id: GOLD_KIND_JEWELERY, name: "Perhiasan" },
    { id: GOLD_KIND_ANTAM_RETRO, name: "Antam Retro" }
];
